import { render, staticRenderFns } from "./ActivityAudio.vue?vue&type=template&id=3682cdf7"
import script from "./ActivityAudio.vue?vue&type=script&lang=ts"
export * from "./ActivityAudio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ActivityAudio.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports